import { BforLogoIcon } from '../assets/BforLogoIcon';
import { BitPandaLogoIcon } from '../assets/BitPandaLogoIcon';
import { BwBankLogoIcon } from '../assets/BwBankLogoIcon';
import { RakbankLogoIcon } from '../assets/RakbankLogoIcon';
import {
  SgforgeInvertedLogoIcon,
  SgforgeLogoIcon,
} from '../assets/SgforgeLogoIcon';
import { AppConfig, OnboardingQuestionnaireType } from './types';

export const STAGING_CONFIGS: AppConfig[] = [
  {
    appId: 1,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen',
    tenantTranslationKeySuffix: 'raiffeisen',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark', //TODO: change this to light after onboarding background token is fixed
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    improvedTracing: true,
    supportedLanguages: ['de', 'en'],
    savingsPlansFrequencySelection: ['DAILY', 'WEEKLY', 'BIWEEKLY', 'MONTHLY'],
  },
  {
    additionalBuyConfirmationText: 'lbbw_buy_success_info',
    additionalSellConfirmationText: 'lbbw_sell_success_info',
    appId: 2,
    appLogo: BitPandaLogoIcon,
    appName: 'LBBW',
    tenantTranslationKeySuffix: 'lbbw',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    landingPageLangIconColorScheme: 'dark', //TODO: change this to light after onboarding background token is fixed
    localPublicFolderPathTo_FAQDocument: '/LBBW-CryptoApp-FAQ-document.pdf',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CORPORATE,
    URLforCustomerSupport:
      'https://lbbwsupport.bitpanda.com/hc/de/requests/new',
    supportedLanguages: ['de', 'en'],
    disableDac8: true,
    skipWelcomePage: true,
    useNativeTermsPreviewOnDesktop: true,
  },
  {
    appId: 3,
    appLogo: RakbankLogoIcon,
    appName: 'Rakbank',
    tenantTranslationKeySuffix: 'rakbank',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    arePdfsOpenedAsLinks: true,
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    // TODO temporary until we are receiving it from BE
    islamicComplianceUrl: 'https://www.rakbank.ae/en/islamic/personal',
    classicOnboardingSuccessfulMessageType: 'withRiskDisclosure',
    currency: 'AED',
    disableLogoutButton: true,
    savingsPlansFrequencySelection: ['DAILY', 'WEEKLY', 'BIWEEKLY', 'MONTHLY'],
    useLegacyOperationUrls: true,
    // TODO temporary until we are receiving user residency
    isUAETenant: true,
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 5,
    minimumSavingsAmount: 100,
    minimumCalendarDaysBeforeExecution: 2,
    paymentDaysBeforeExecution: 2,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'RAKBANK App',
    reportsTypeFilterItems: [
      'ALL',
      'ACCOUNT_STATEMENT',
      'TRADES_VALUE_ADDED_TAX',
    ],
    supportedLanguages: ['ar', 'en'],
    disableDac8: true,
  },
  {
    appId: 4,
    appLogo: SgforgeLogoIcon,
    appLogoInverted: SgforgeInvertedLogoIcon,
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    appName: 'SGForge',
    tenantTranslationKeySuffix: 'sgforge',
    welcomeContinueButtonVisual: 'primary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    onboardingSuccessfulInfoLayoutVariant: 'dark',
    currency: 'EUR',
    isByol: true,
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    supportedLanguages: ['en'],
    disableDac8: true,
  },
  {
    appId: 5,
    appLogo: BitPandaLogoIcon,
    appName: 'Ribbon',
    tenantTranslationKeySuffix: 'ribbon',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'GBP',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    landingPageLangIconColorScheme: 'dark', //TODO: change this to light after onboarding background token is fixed
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    improvedTracing: true,
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 6,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Tirol',
    tenantTranslationKeySuffix: 'raiffeisen_tirol',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    improvedTracing: true,
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 7,
    appLogo: BforLogoIcon,
    appName: 'BFOR',
    tenantTranslationKeySuffix: 'bfor',
    welcomeContinueButtonVisual: 'primary',
    welcomeScreenBadgesVisual: 'outlineNeutralDark',
    welcomeScreenInfoLayoutVariant: 'primary',
    onboardingSuccessfulInfoLayoutVariant: 'dark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'BFOR App',
    improvedTracing: true,
    supportedLanguages: ['en', 'fr'],
  },
  {
    appId: 8,
    appLogo: BitPandaLogoIcon,
    bankLogo: BwBankLogoIcon,
    appName: 'BW Bank',
    tenantTranslationKeySuffix: 'bw_bank',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'BW Bank-App',
    improvedTracing: true,
    supportedLanguages: ['en', 'de'],
    settlementType: 'TYPE_3',
    automaticWithdrawalsDefaultEnabled: true,
    disableDac8: true,
    supportPhoneNumber: '0711 124-44466',
    supportEmail: 'kontakt@bw-bank.de',
    useNativeTermsPreviewOnDesktop: true,
  },
  {
    appId: 9,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Steiermark',
    tenantTranslationKeySuffix: 'raiffeisen_steiermark',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    improvedTracing: true,
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 10,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Salzburg',
    tenantTranslationKeySuffix: 'raiffeisen_salzburg',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    improvedTracing: true,
    supportedLanguages: ['de', 'en'],
    savingsPlansFrequencySelection: ['DAILY', 'WEEKLY', 'BIWEEKLY', 'MONTHLY'],
  },
  {
    appId: 11,
    appLogo: BitPandaLogoIcon,
    appName: 'Raiffeisen Vorarlberg',
    tenantTranslationKeySuffix: 'raiffeisen_vorarlberg',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/de/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    minimumSavingsAmount: 10,
    minimumCalendarDaysBeforeExecution: 4,
    paymentDaysBeforeExecution: 3,
    maxDaysFromMonthEndForSavingsExecution: 2,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'Mein ELBA-App',
    improvedTracing: true,
    supportedLanguages: ['de', 'en'],
  },
  {
    appId: 12,
    appLogo: BitPandaLogoIcon,
    appName: 'iCard',
    tenantTranslationKeySuffix: 'icard',
    welcomeContinueButtonVisual: 'secondary',
    welcomeScreenBadgesVisual: 'filledNeutralDark',
    classicOnboardingSuccessfulMessageType: 'withoutRiskDisclosure',
    currency: 'EUR',
    bitpandaAcademyPageUrl: 'https://www.bitpanda.com/en/academy',
    landingPageLangIconColorScheme: 'dark',
    minimumFiatTradeAmountForSingleCurrency: 1,
    onboardingType: OnboardingQuestionnaireType.CLASSIC,
    partnerHostAppName: 'iCard App',
    improvedTracing: true,
    supportedLanguages: ['en', 'it', 'fr', 'de'],
    savingsPlansFrequencySelection: ['DAILY', 'WEEKLY', 'BIWEEKLY', 'MONTHLY'],
  },
];
